import React from "react";
import logo from "../../assets/images/logo/logo.png";
import fb from "../../assets/images/icons/facebook.svg";
import twt from "../../assets/images/icons/twitter.svg";
import wa from "../../assets/images/icons/whatsapp.svg";

const Footer = () => {
  return (
    <section className="footer section-spacing-20 no-padding-bottom">
      <div className="footer-animations"></div>
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-content section-spacing-50">
              <div className="footer-menu-sections-container">
                <div className="footer-menu-section">
                  <h3>company</h3>
                  <ul>
                    <li>
                      <a href="/about-us">about us</a>
                    </li>
                    <li>
                      <a href="/about-us">Our Gallery</a>
                    </li>
                    <li>
                      <a href="/contact-us">contact us</a>
                    </li>
                    <li>
                      <a href="/services">Our Services</a>
                    </li>
                    <li>
                      <a href="/#">policies &amp; Safety</a>
                    </li>
                  </ul>
                </div>
                <div className="footer-menu-section">
                  <h3>core markets</h3>
                  <ul>
                    <li>
                      <a href="/#">Commercial Buildings</a>
                    </li>
                    <li>
                      <a href="/#">Residential Buildings</a>
                    </li>
                    <li>
                      <a href="/#">Roads and Bridges</a>
                    </li>
                    <li>
                      <a href="/#">Schools &amp; Hospitals</a>
                    </li>
                    <li>
                      <a href="/#">Warehouses &amp; Gates</a>
                    </li>
                  </ul>
                </div>
                <div className="footer-menu-section">
                  <h3>Our services</h3>
                  <ul>
                    <li>
                      <a href="#">General Contracting </a>
                    </li>
                    <li>
                      <a href="#">Construction Management</a>
                    </li>
                    <li>
                      <a href="#">Design - Build </a>
                    </li>
                    <li>
                      <a href="#">Pre-construction &amp; Planning </a>
                    </li>
                    <li>
                      <a href="#">Special Projects </a>
                    </li>
                  </ul>
                </div>
                <div className="footer-menu-section">
                  <h3>Core values</h3>
                  <ul>
                    <li>
                      <a href="#">Proactive</a>
                    </li>
                    <li>
                      <a href="#">Sustainability</a>
                    </li>
                    <li>
                      <a href="#">Customer centricity. </a>
                    </li>
                    <li>
                      <a href="#">innovation</a>
                    </li>
                    <li>
                      <a href="#">Integrity</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="footer-about">
                <div className="footer-brand flex">
                  <img src={logo} alt="JMSTONE LOGO" />
                  <div>
                    <p>Hai-Malakal, Juba, South Sudan</p>
                    <p>+211 921 782 856/+211 923 562 600</p>
                    <p>info@negash.co | project@negash.co</p>
                  </div>
                </div>
                <div className="footer-copyright">
                  <p className="flex">
                    <a href="#">
                      <img src={fb} alt="Facebook" />
                    </a>
                    <a href="#">
                      <img src={twt} alt="Twitter" />
                    </a>
                    <a href="#">
                      <img src={wa} alt="WhatsApp" />
                    </a>
                  </p>
                  <p>&copy; 2025 NEGASH CONSTRUCTION COMPANY LTD,</p>
                  <p>All Rights Reserved.</p>
                </div>
              </div>
            </div>
            <div className="designer section-spacing-10 uppercase">
              <div className="design-inner white center">
                <p className=" rich-small">
                  Website by{" "}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://ntuna.com"
                    className="orange"
                  >
                    NTUNA.COM
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
